module.exports = {
	"reports": {
		"group_title": "Reports",
		"10_minutes_hint": "The reports are missing data on orders created in the last 10 minutes",
		"common": {
			"date": "Date",
			"week": "Week",
			"month": "Month",
			"year": "Year",
			"currency": "Currency",
			"order_currency": "Order currency",
			"billing_currency": "Billing currency",
			"processor": "Processor",
			"system": "System",
			"project": "Project",
			"type": "Type",
			"locale": "Locale",
			"customer_country": "Customer country",
			"token_country": "Country by IP",
			"jurisdiction": "Jurisdiction",
			"bank": "Bank",
			"platform": "Platform",
			"user": "User",
			"customer_area": "Customer area",
			"token_area": "IP area",
			"load_report_message": "Set filters and click Show button",
			"widget_mode": "Widget mode",
			"billing_type": "Billing type",
			"ftd": "FTD",
			"deposit_segment": "Deposit segment",
			"refcode": "Refcode",
			"purse_country": "Purse country",
			"failure_type": "Failure type",
			"failure_subtype": "Failure subtype",
			"failure_code": "Failure code",
			"failure_message": "Failure message",
			"vwo_variation": "VWO Variation",
			"card_type": "Card type",
			"provider": "Provider",
			"operation_type": "Operation type",
			"payment_flow": "Payment flow",
			"three_ds_eci": "3DS ECI",
			"three_ds_flow": "3DS flow",
			"cascade_number": "Cascade number",
			"attempt_number": "Attempt number",
			"decline_reason": "Decline reason",
			"decline_type": "Decline type",
			"decline_code": "Decline code",
			"decline_message": "Decline message",
			"widget_type": "Widget type",
			"widget_submode": "Widget opening location",
			"app_type": "App type",
			"device_type": "Device type",
			"os_type": "OS type"
		},
		"deposit_passability": {
			"title": "Deposit passability",
			"title_v2": "Deposit passability v2",
			"total_count": "Total deposits",
			"success_count": "Paid",
			"user_count": "Total users",
			"successful_user_count": "Successful users",
			"terminal": "Terminal failure",
			"timeout": "Timeout",
			"success_count_without_timeouts": "Success without timeouts",
			"processing_time_without_timeouts": "Average processing time without timeouts",
			"total_clean_deposits": "Total clean deposits",
			"psp_errors": "PSP errors",
			"psp_errors_ratio": "PSP errors ratio",
			"clean_acceptance_ratio": "Clean acceptance ratio",
			"cancel_errors": "Cancel errors",
			"cancel_ratio": "Cancel ratio",
			"rejected_errors": "Rejected errors",
			"rejected_ratio": "Rejected ratio",
			"user_errors": "User errors",
			"user_errors_ratio": "User errors ratio",
			"unknown_errors": "Unknown errors",
			"unknown_errors_ratio": "Unknown errors ratio"
		},
		"withdraw_passability": {
			"title": "Withdraw passability",
			"total_count": "Total withdrawals",
			"success_count": "Success",
			"rejected_count": "Rejected"
		},
		"passability": {
			"processing_time": "Average processing time",
			"user_failure": "User failure",
			"processor_decline": "Processor decline",
			"insufficient_funds": "Insufficient funds",
			"processing_time_by_processor": "Processing time by processor"
		},
		"fees": {
			"title": "Fees",
			"deposit_amount": "Deposit amount",
			"deposit_billing_amount": "Deposit amount (billing)",
			"deposit_count": "Deposit count",
			"withdraw_amount": "Withdrawal amount",
			"withdraw_billing_amount": "Withdrawal amount (billing)",
			"withdraw_count": "Withdrawal count",
			"deposit_fee_external_amount": "Fee amount (external, IN)",
			"withdraw_fee_external_amount": "Fee amount (external, OUT)",
			"deposit_fee_amount": "Processor fee (calculated, IN)",
			"deposit_fee_subprocessor_amount": "Subprocessor fee (calculated, IN)",
			"deposit_fee_percent": "Processor fee % (IN)",
			"deposit_fee_subprocessor_percent": "Subprocessor fee % (IN)",
			"withdraw_fee_amount": "Processor fee (calculated, OUT)",
			"withdraw_fee_subprocessor_amount": "Subprocessor fee (calculated, OUT)",
			"withdraw_fee_percent": "Processor fee % (OUT)",
			"withdraw_fee_subprocessor_percent": "Subprocessor fee % (OUT)",
			"fee_amount": "Fee amount (IN + OUT)",
			"fee_percent": "Fee % (IN + OUT)",
			"fee_sum": "Fee turnover, %"
		},
		"customers_turnover": {
			"title": "Customers turnover",
			"player": "Player",
			"deposit_amount": "Deposit amount",
			"withdraw_amount": "Withdrawal amount"
		},
		"transition_history": {
			"title": "Withdraws: Transition history",
			"page_title": "Orders status history",
			"old_status": "Old status",
			"new_status": "New status",
			"change_interval": "Status changing duration",
			"created_at": "Status changing date",
			"order_created_at": "Order creation date"
		},
		"traffic_distribution": {
			"title": "Traffic distribution",
			"system": "System",
			"deposit_count": "Deposit count",
			"withdraw_count": "Withdrawal count",
			"deposit_amount": "Deposit amount",
			"withdraw_amount": "Withdrawal amount",
			"deposit_percent_within_system": "Deposit % within system",
			"deposit_percent_within_provider": "Deposit % within provider",
			"withdraw_percent_within_system": "Withdraw % within system",
			"withdraw_percent_within_provider": "Withdraw % within provider"
		},
		"transactions": {
			"title": "Transactions report",
			"deposit_amount": "Deposit amount",
			"deposit_count": "Deposit count",
			"withdraw_amount": "Withdrawal amount",
			"withdraw_count": "Withdrawal count",
			"deposit_fee_amount": "Processor fee amount (Calculated, IN)",
			"deposit_fee_subprocessor_amount": "Subprocessor fee amount (Calculated, IN)",
			"deposit_fee_external_amount": "Fee amount (External, IN)",
			"withdraw_fee_amount": "Processor fee amount (Calculated, OUT)",
			"withdraw_fee_subprocessor_amount": "Subprocessor fee amount (Calculated, OUT)",
			"withdraw_fee_external_amount": "Fee amount (External, OUT)",
			"fee_sub": "Fee in-out, %",
			"fee_sum": "Fee turnover, %",
			"refund_amount": "Refunds amount",
			"refund_count": "Refunds count",
			"processor_channel": "Processor channel",
			"failed_deposit_count_without_timeouts": "Failed deposit count (without timeouts)",
			"failed_withdraw_count_without_timeouts": "Failed withdrawal count (without timeouts)"
		},
		"global_orders": {
			"title": "Global orders report",
			"total_deposit_count": "Total deposit count",
			"successful_deposit_count": "Successful deposit count",
			"successful_deposit_sum": "Successful deposit sum",
			"successful_deposit_billing_sum": "Successful deposit sum (billing)",
			"deposit_fee_sum": "Processor fee sum (Calculated, IN)",
			"deposit_fee_subprocessor_sum": "Subprocessor fee sum (Calculated, IN)",
			"deposit_customer_count": "Deposit customer count",
			"successful_deposit_customer_count": "Successful deposit customer count",
			"successful_withdraw_count": "Successful withdrawal count",
			"successful_withdraw_sum": "Successful withdrawal sum",
			"successful_withdraw_billing_sum": "Successful withdrawal sum (billing)",
			"withdraw_fee_sum": "Processor fee sum (Calculated, OUT)",
			"withdraw_fee_subprocessor_sum": "Subprocessor fee sum (Calculated, OUT)",
			"withdraw_fee_external_sum": "Fee sum (External, IN)",
			"deposit_fee_external_sum": "Fee sum (External, OUT)"
		},
		"processor_external_actions": {
			"title": "Financial report",
			"merchant_name": "Merchant Name",
			"payment_method": "Payment Method",
			"payment_type": {
				"title": "Payment type",
				"deposit": "Deposit",
				"withdraw": "Withdrawal",
				"refund": "Refund"
			},
			"total_count": "Total count",
			"total_volume": "Total Volume",
			"total_fee": "Total Fee",
			"total_fee_percentage": "Total Fee %",
			"authentication_fixed_fee": "Authentication Fixed Fee",
			"authorization_fixed_fee": "Authorization Fixed Fee",
			"intelligent_acceptance_fixed_fee": "Intelligent Acceptance Fixed Fee",
			"interchange_fixed_fee": "Interchange Fixed Fee",
			"network_token_provisioning_fixed_fee": "Network Token Provisioning Fixed Fee",
			"network_token_update_fixed_fee": "Network Token Update Fixed Fee",
			"payout_success_fixed_fee": "Payout Success Fixed Fee",
			"payout_success_variable_fee": "Payout Success Variable Fee",
			"premium_variable_fee": "Premium Variable Fee",
			"refund_fixed_fee": "Refund Fixed Fee",
			"scheme_fixed_fee": "Scheme Fixed Fee",
			"scheme_variable_fee": "Scheme Variable Fee"
		},
		"banned_purses": {
			"id": "ID",
			"title": "Banned purses",
			"scope": "Scope",
			"reason": "Reason",
			"comment": "Comment",
			"createdAt": "Card blocking date",
			"customerId": "Customer ID",
			"user": "Customer",
			"accountForDisplay": "Account",
			"orderGuid": "Payment ID (GUID)",
			"system": "System"
		},
		"external_operations": {
			"title": "External operations",
			"total_count": "Total count",
			"successful_count": "Successful count",
			"decline_count": "Decline count",
			"success_percent": "Success percent",
			"decline_percent": "Decline percent",
			"total_amount": "Total amount",
			"success_amount": "Success amount",
			"declined_amount": "Declined amount",
			"total_provider_fee_amount": "Total provider fee amount"
		}
	}
};